
@file:Suppress("unused")
package tk.mallumo.compose.navigation




/**
 * @see one.devsbox.www.ui.login.LoginUI
 * 
 */
val Node.Companion.LoginUI get() = Node("one.devsbox.www.ui.login.LoginUI") //args: null

/**
 * @see one.devsbox.www.ui.resources.detail.ResourceUI
 * @see one.devsbox.www.tools.ArgsId
 */
val Node.Companion.ResourceUI get() = Node("one.devsbox.www.ui.resources.detail.ResourceUI") //args: one.devsbox.www.tools.ArgsId

/**
 * @see one.devsbox.www.ui.resources.ListingResourcesUI
 * @see one.devsbox.www.ui.resources.ArgsListingResource
 */
val Node.Companion.ListingResourcesUI get() = Node("one.devsbox.www.ui.resources.ListingResourcesUI") //args: one.devsbox.www.ui.resources.ArgsListingResource

/**
 * @see one.devsbox.www.ui.users.detail.UserDUI
 * @see one.devsbox.www.tools.ArgsId
 */
val Node.Companion.UserDUI get() = Node("one.devsbox.www.ui.users.detail.UserDUI") //args: one.devsbox.www.tools.ArgsId

/**
 * @see one.devsbox.www.ui.users.activity.UsersActivityUI
 * @see one.devsbox.www.tools.ArgsId
 */
val Node.Companion.UsersActivityUI get() = Node("one.devsbox.www.ui.users.activity.UsersActivityUI") //args: one.devsbox.www.tools.ArgsId

/**
 * @see one.devsbox.www.ui.users.ListingUsersUI
 * 
 */
val Node.Companion.ListingUsersUI get() = Node("one.devsbox.www.ui.users.ListingUsersUI") //args: null

/**
 * @see one.devsbox.www.ui.users.edit.UserEUI
 * @see one.devsbox.www.tools.ArgsId
 */
val Node.Companion.UserEUI get() = Node("one.devsbox.www.ui.users.edit.UserEUI") //args: one.devsbox.www.tools.ArgsId

/**
 * @see one.devsbox.www.ui.devices.detail.DeviceDUI
 * @see one.devsbox.www.tools.ArgsId
 */
val Node.Companion.DeviceDUI get() = Node("one.devsbox.www.ui.devices.detail.DeviceDUI") //args: one.devsbox.www.tools.ArgsId

/**
 * @see one.devsbox.www.ui.devices.ListingDevicesUI
 * 
 */
val Node.Companion.ListingDevicesUI get() = Node("one.devsbox.www.ui.devices.ListingDevicesUI") //args: null

/**
 * @see one.devsbox.www.ui.devices.edit.DeviceEUI
 * @see one.devsbox.www.tools.ArgsId
 */
val Node.Companion.DeviceEUI get() = Node("one.devsbox.www.ui.devices.edit.DeviceEUI") //args: one.devsbox.www.tools.ArgsId

/**
 * @see one.devsbox.www.ui.campaigns.detail.CampaignDUI
 * @see one.devsbox.www.tools.ArgsId
 */
val Node.Companion.CampaignDUI get() = Node("one.devsbox.www.ui.campaigns.detail.CampaignDUI") //args: one.devsbox.www.tools.ArgsId

/**
 * @see one.devsbox.www.ui.campaigns.ListingCampaignsUI
 * 
 */
val Node.Companion.ListingCampaignsUI get() = Node("one.devsbox.www.ui.campaigns.ListingCampaignsUI") //args: null

/**
 * @see one.devsbox.www.ui.campaigns.edit.CampaignEUI
 * @see one.devsbox.www.tools.ArgsId
 */
val Node.Companion.CampaignEUI get() = Node("one.devsbox.www.ui.campaigns.edit.CampaignEUI") //args: one.devsbox.www.tools.ArgsId

/**
 * @see one.devsbox.www.ui.company.ListingCompanyUI
 * 
 */
val Node.Companion.ListingCompanyUI get() = Node("one.devsbox.www.ui.company.ListingCompanyUI") //args: null

/**
 * @see one.devsbox.www.ui.home.HomeUI
 * 
 */
val Node.Companion.HomeUI get() = Node("one.devsbox.www.ui.home.HomeUI") //args: null

/**
 * @see one.devsbox.www.ui.widgets.EmptyUI
 * 
 */
val Node.Companion.EmptyUI get() = Node("one.devsbox.www.ui.widgets.EmptyUI") //args: null

/**
 * @see one.devsbox.www.ui.locations.detail.LocationDUI
 * @see one.devsbox.www.tools.ArgsId
 */
val Node.Companion.LocationDUI get() = Node("one.devsbox.www.ui.locations.detail.LocationDUI") //args: one.devsbox.www.tools.ArgsId

/**
 * @see one.devsbox.www.ui.locations.ListingLocationUI
 * 
 */
val Node.Companion.ListingLocationUI get() = Node("one.devsbox.www.ui.locations.ListingLocationUI") //args: null

/**
 * @see one.devsbox.www.ui.locations.edit.LocationEUI
 * @see one.devsbox.www.tools.ArgsId
 */
val Node.Companion.LocationEUI get() = Node("one.devsbox.www.ui.locations.edit.LocationEUI") //args: one.devsbox.www.tools.ArgsId

/**
 * @see one.devsbox.www.ui.uploader.UploaderUI
 * 
 */
val Node.Companion.UploaderUI get() = Node("one.devsbox.www.ui.uploader.UploaderUI") //args: null

/**
 * @see one.devsbox.www.ui.cmd.CmdUI
 * @see one.devsbox.www.tools.ArgsId
 */
val Node.Companion.CmdUI get() = Node("one.devsbox.www.ui.cmd.CmdUI") //args: one.devsbox.www.tools.ArgsId
